import { cacheableQueryOptions, useAPI } from '@/services';
import { UseQueryOptions } from 'react-query';
import { useGetFundCodeFromQuery } from '@/modules/invest/hooks/useGetFundCodeFromQuery';

export const useGetFundDetailsData = (
  reactQueryOptions?: UseQueryOptions<any>
) => {
  const fundCode = useGetFundCodeFromQuery();

  return useAPI(['fund', 'getFundDetail'], {
    input: {
      code: fundCode,
    },
    reactQueryOptions: {
      ...cacheableQueryOptions,
      ...(reactQueryOptions || {}),
    },
  });
};
